import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import Text from 'components/shared/Text'

export const Wrapper = styled(Box)`
    width: 100%;
    background: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 9px;

    p > span {
        margin-left: 5px;
    }
`

export const ButtonWrapper = styled(Box)`
    align-self: end;

    @media ${respondAbove.xl} {
        align-self: center;
    }

    span {
        margin-right: 24px;
    }
`

export const DatesWrapper = styled(Box)`
    ${Text} {
        margin-left: 8px;
        position: relative;
    }

    ${Text}::before {
        position: absolute;
        content: '';
        left: -8px;
        top: 0;
        width: 3px;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.primary_500};
        border-radius: 8px;
    }
`
